import { Injectable } from '@angular/core';
import { AmberApi } from 'app/core/models/api-helpers';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { RequestService } from 'app/core/services/request.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CompleteProfileService {

  getStepsConfiguration(initialState: any): { cardType: string, bucket?: string, key?: string, text?: string, folds: number }[] {
    // console.log(guidance);
    initialState.steps = [];
      initialState.steps.push(
        { key: 'overview', icon: 'fa fa-list-alt', title: 'onboarding.overview.step.title' },
        { key: 'branding', icon: 'fa fa-file-image', title: 'onboarding.branding.step.title' },
        { key: 'employees', icon: 'fa fa-address-book', title: 'onboarding.invite.employees.step.title' },
      );
    let data: { cardType: string, image?: string, text?: string, folds: number, title: string }[] = [];
    data = this.getAdminConf();
    return data;
  }

  getAdminConf() {
    return [
      { cardType: 'overview', folds: 1, title: 'onboarding.overview.title' },
      {
        cardType: 'branding',
        image: 'onboarding.invite.branding.imageURL',
        text: 'onboarding.cover-logo.text',
        folds: 3,
        title: 'onboarding.branding.title'
      },
      {
        cardType: 'employees',
        image: 'onboarding.invite.employees.imageURL',
        text: 'onboarding.invite.employees.instructions',
        folds: 3,
        title: 'onboarding.employees.invite.title'
      }];
  }

  private profile$: Observable<any>;
  private agoraDomain$: Observable<any>;
  private domain$: Observable<any>;
  private reloadProfile$ = new Subject<void>();
  private reloadAgoraDomain$ = new Subject<void>();
  private reloadDomain$ = new Subject<void>();
  
  constructor(
    private profileService: ProfileService,
    private configService: ConfigService,
    private requestService: RequestService
  ) { }


  resetProfile() {
    this.reloadProfile$.next();
    this.profile$ = null;
  }

  resetAgoraDomain() {
    this.reloadAgoraDomain$.next();
    this.agoraDomain$ = null;
  }

  resetDomain() {
    this.reloadDomain$.next();
    this.domain$ = null;
  }
  getDomainDetails(): Observable<any> {
    if (!this.domain$) {
      let url = this.configService.get('server').url +
        this.configService.get('endpoints').organization.domain.details.api;
      this.domain$ = this.requestService.get(url).takeUntil(this.reloadDomain$).extract(AmberApi.Data).shareReplay(1);
    }
    return this.domain$;
  }

  getOrganizationDetails(): Observable<any> {
    let url = this.configService.get('server').url +
      this.configService.get('endpoints').organization.organizationDetails.details.api;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  // getEmployeeDetails(): Observable<any> {
  //   if (!this.profile$) {
  //     this.profile$ = this.profileService.getProfile().takeUntil(this.reloadProfile$).extract(AmberApi.Data)
  //     .filter(body => this.checkIfIncludeBuyerOrSelleGroup(body['groups'])).shareReplay(1);
  //   }
  //   return this.profile$;
  // }

  getRoles(): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.employeeRoles.api;
    return this.requestService.get(url).extract(AmberApi.Data);
  }

  getEmployees() {
    let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.list.api;
    return this.requestService.get(url).extract(AmberApi.Data).shareReplay(1);
  }

  getAccountDomain(): Observable<any> {
    if (!this.agoraDomain$) {
      let url = this.configService.get('server').url + this.configService.get('endpoints').agora.accounts.domain.api;
      this.agoraDomain$ = this.requestService.get(url).takeUntil(this.reloadAgoraDomain$).extract(AmberApi.Data).shareReplay(1);
    }
    return this.agoraDomain$;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/complete-profile/complete-profile.service.ts